import React from 'react'
import { useBoolean, useMount } from 'react-use'

import { ReactComponent as Logo } from 'assets/brand-logo.svg'

import { Root } from './BrandLogo.styled.js'
import { useApp } from 'store/AppStore.js'

const BrandLogo = ({ currentView, isShort }) => {
  const [mounted, setMounted] = useBoolean(false)
  const { goHome } = useApp()
  

  useMount(() => {
    setMounted(true)
  })
  const variant = currentView === 'landing' ? 'white' : 'lightBlue'

  return (
    <Root show={mounted} variant={variant} isShort={isShort}>
      <button style={{ position:"relative",
    zIndex: 35000,
    background:"transparent",
    border: "none",
    pointerEvents: "auto"}} onClick={() => goHome() }>
      <Logo></Logo>
      </button>
    </Root>
  )
}

export default BrandLogo
